if (!customElements.get('expandable-description')) {
  customElements.define('expandable-description', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-collapsible') || this.controller) return;
      this.body = this.querySelector('.product-description__body');
      this.button = this.querySelector('button');
      if (!this.body || !this.button) return;
      this.controller = new AbortController();
      this.button.addEventListener('click', () => this.setExpanded(!this.expanded), { signal: this.controller.signal });
      // Keyboard users must never focus a link concealed by the preview.
      this.body.addEventListener('focusin', () => this.setExpanded(true), { signal: this.controller.signal });
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.body);
      this.measure();
    }
    measure() {
      const limit = parseFloat(getComputedStyle(this).getPropertyValue('--description-preview-height')) || 220;
      this.hasOverflow = this.body.scrollHeight > limit + 1;
      this.button.hidden = !this.hasOverflow;
      this.toggleAttribute('data-collapsed', this.hasOverflow && !this.expanded);
    }
    setExpanded(expanded) {
      this.expanded = expanded;
      this.button.setAttribute('aria-expanded', String(expanded));
      this.querySelector('[data-description-more]').hidden = expanded;
      this.querySelector('[data-description-less]').hidden = !expanded;
      this.measure();
      if (!expanded) this.querySelector('.product-description__viewport').scrollTop = 0;
      if (!expanded && this.getBoundingClientRect().bottom < 0) this.scrollIntoView({ block: 'start' });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
